module.exports = __webpack_public_path__ + "static/media/2 (30).14411197.jpg";